
import theme from '@/assets/theme.scss';
import { lightweightChartMixin } from '@/mixins';

export default {
    name: 'MarketAnalysisChartWidget',

    mixins: [lightweightChartMixin],

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            chart: null,
        }
    },

    watch: {
        isDarkMode: {
            immediate: true,
            handler(newState) {
                this.updateLineSeriesStyle(newState)
            }
        },
        data: {
            immediate: true,
            handler() {
                if (this.chart) {
                    this.drawChart()
                }
            }
        },
    },

    beforeMount() {
        window.addEventListener('resize', this.setChartWidth)
    },

    mounted() {
        this.createChart({ height: 200 })
        this.drawChart()
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.setChartWidth)
    },

    methods: {
        drawChart() {
            if (!this.data.datapoints) {
                return;
            }
            if (this.lineSeries) {
                this.lineSeries.setData((this.data.datapoints ?? []).map(datapoint => {
                    return {
                        time: this.getTimezoneCorrectedTime(datapoint.t, true),
                        value: datapoint.c
                    }
                }));

                this.chart.timeScale().fitContent();

                return;
            }

            this.lineSeries = this.chart.addAreaSeries(
                {
                    lineWidth: 2,
                    lineColor: this.isDarkMode ? theme['bg-brand-solid-dark'] : theme['bg-brand-solid-light'],
                    lineType: 2,
                    //add opacity for area colors
                    topColor: (this.isDarkMode ? theme['bg-brand-solid-dark'] : theme['bg-brand-solid-light']) + '55',
                    bottomColor: (this.isDarkMode ? theme['bg-brand-solid-dark'] : theme['bg-brand-solid-light']) + '00',
                }
            );

            this.lineSeries.setData((this.data.datapoints ?? []).map(datapoint => {
                return {
                    time: this.getTimezoneCorrectedTime(datapoint.t, true),
                    value: datapoint.c
                }
            }));

            this.chart.timeScale().fitContent();
        },
        updateLineSeriesStyle(isDarkMode) {
            this.lineSeries?.applyOptions(
                {
                    color: isDarkMode ? theme['bg-brand-solid-dark'] : theme['bg-brand-solid-light'],
                    topColor: (this.isDarkMode ? theme['bg-brand-solid-dark'] : theme['bg-brand-solid-light']) + '55',
                    bottomColor: (this.isDarkMode ? theme['bg-brand-solid-dark'] : theme['bg-brand-solid-light']) + '00',
                }
            )
        },
        setChartWidth() {
            if (this.chart && this.$refs['chartWrapper']) {
                this.chart.applyOptions({
                    width: this.$refs['chartWrapper'].clientWidth,
                })
            }
        },
    },
}
